import { DisclaimerContext } from '@views/contexts/DisclaimerContext'
import { useContext } from 'react'

export const useDisclaimer = () => useContext(DisclaimerContext)
